<template>
  <div>
    <Container class="container-sm-none">
      <Progressbar :step="7" :step-count="model.stepCount">
        Details of Residence
      </Progressbar>
      <Card class="card-shadow">
        <div class="width-lg">
          <div class="pl-10 pl-md-0 pr-10 pr-md-0">
            <Collapse
              v-for="(person, index) in model.insuredPersons.array_hd7ov6$_0"
              :key="index + 1"
              :opened-index="openedIndex"
              @change="setOpened"
              @handle-next-step="handleNextStep"
              @child-loaded="handleCollapseLoaded"
              :tried-go-to-next-step="triedGoToNextStep"
              :index="index"
              :model="model"
              :person-count="model.insuredPersons.array_hd7ov6$_0.length"
              :errors="errors"
            >
              <template v-slot:title>
                <p v-if="person.name && person.surname">
                  {{`${person.name} ${person.surname}`}}
                </p>
                <p v-else>
                  Policyholder {{`${index + 1}`}}
                </p>
              </template>
              <PersonAddress
                :person="person"
                :model="model"
                :errors="errors"
                :person-index="index"
              />
            </Collapse>

            <InsuranceCard
              v-if="canInsureAnotherPerson"
              class="mt-20 mb-10"
              title='Insure Another Person'
              :value="isPersonSelected"
              :enum-value="personSelected"
              @input="selectOtherPerson"
              v-scroll-to-error
            >
              <IconAdultPerson slot="left-icon" />
              <IconPlus class="ic-plus-icon" />
            </InsuranceCard>

            <ButtonGroup class="pt-10">
              <Button
                class="btn-outline-tertiary w-full"
                :icon-left="require('@/assets/svg/icon-left-gray.svg')"
                @click="redirectBack"
              >
                Back
              </Button>
              <Button
                class="btn-primary w-full"
                :icon-right="require('@/assets/svg/icon-right-white.svg')"
                @click="redirectToNext"
                v-scroll-to-error
              >
                Continue
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </Card>
    </Container>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import Container from '@/components/Container/Container.vue';
import Progressbar from '@/components/Progressbar/Progressbar.vue';
import Button from '@/components/Button/Button.vue';
import ButtonGroup from '@/components/ButtonGroup/ButtonGroup.vue';
import routes from '@/mixins/routes';
import PersonAddress from '@/pagesComponents/PersonAddress.vue';
import enums from '@/mixins/enums';
import lead from '@/mixins/lead';
import Collapse from '@/components/Collapse/Collapse.vue';
import IconPlus from '@/components/Icons/IconPlus.vue';
import InsuranceCard from '@/components/InsuranceCard/InsuranceCard.vue';
import IconAdultPerson from '@/components/Icons/IconAdultPerson.vue';
import GA from '@/mixins/GA';

export default {
  name: 'PersonAddressPage',
  mixins: [routes, enums, lead, GA],
  components: {
    IconAdultPerson,
    InsuranceCard,
    IconPlus,
    Collapse,
    Button,
    PersonAddress,
    Card,
    Container,
    Progressbar,
    ButtonGroup,
  },
  data() {
    return {
      openedIndex: -1,
      triedGoToNextStep: false,
      isPersonSelected: {
        value: false,
      },
      personSelected: {
        value: true,
      },
    };
  },
  props: {
    errors: { type: Array, required: true },
    model: { type: Object, required: true },
  },
  methods: {
    redirectToNext() {
      this.triedGoToNextStep = true;
      if (this.errors.length === 0) {
        // toto je pruser...
        // tymto som sa snazil asi vyriesit to, ze ak idem z tohto kroku dalej
        // a nachadzam sa vo flowe viacerych osob a nie som na poslednej osobe tak
        // nechcem ist na dalsi step
        // ale vlastne chcem ist na krok 3 nasledujucej osoby
        // je mozne ze tuto logiku bude treba riesit vsade kde existuje moznost pridania dalsej osoby
        // je rovnako mozne ze tato logika sa da vyriesit aj nejako krajsie
        if (this.model.currentPersonIndex < this.model.insuredPersons.array_hd7ov6$_0.length - 1
          && this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.includes(9)) {
          this.model.currentPersonIndex += 1;
          this.model.currentPersonStepIndex = 0;
          let nextStep = this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0[0];
          if (!nextStep) {
            nextStep = 3;
          }
          this.saveLead(nextStep);
          this.$router.goToStep(nextStep);
        } else {
          const indexOfChildWithoutRepresentative = this.model.insuredPersons.array_hd7ov6$_0.findIndex((person) => this.isChildWithoutFilledLegalRepresentative(person));

          if (indexOfChildWithoutRepresentative >= 0) {
            this.model.currentPersonIndex = indexOfChildWithoutRepresentative;
            if (!this.model.insuredPersons.array_hd7ov6$_0[indexOfChildWithoutRepresentative].visitedSteps.array_hd7ov6$_0.includes(12)) {
              this.model.insuredPersons.array_hd7ov6$_0[indexOfChildWithoutRepresentative].visitedSteps.array_hd7ov6$_0.push(12);
            }
            this.model.currentPersonStepIndex = this.model.insuredPersons.array_hd7ov6$_0[indexOfChildWithoutRepresentative].visitedSteps.array_hd7ov6$_0.length - 1;
            this.saveLead(12);
            this.$router.goToStep(12);
          } else {
            if (!this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.includes(17)) {
              this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.push(17);
            }
            this.model.currentPersonStepIndex += 1;
            this.saveLead(17);
            this.$router.goToStep(17);
          }
        }
      }
    },
    redirectBack() {
      this.$router.goToStep(this.getNearestPreviousAvailableStep());
    },
    handleCollapseLoaded() {
      this.openedIndex = this.model.currentPersonIndex;
    },
    handleNextStep() {
      this.triedGoToNextStep = false;
    },
    setOpened(index) {
      this.openedIndex = index;
    },
    selectOtherPerson() {
      this.isPersonSelected = this.personSelected;
      if (this.errors.length === 0) {
        if (!this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.includes(9)) {
          this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.push(9);
        }
        this.model.currentPersonStepIndex += 1;
        this.$router.goToStep(9);
      }
    },
    isChildWithoutFilledLegalRepresentative(person) {
      return !person.isAdult
        && (person.firstLegalRepresentative.personIndex === null
          || (person.firstLegalRepresentative.personIndex === -1
            && person.firstLegalRepresentative.isAddressSameAsChild === null));
    },
  },
  computed: {
    canInsureAnotherPerson() {
      return this.model.insuredPersons.array_hd7ov6$_0.length < 5;
    },
  },
  created() {
    this.model.step = 8;
    if (this.model.lastStep < 8) this.model.lastStep = 8;
  },
  mounted() {
    this.funnelStep('Údaje o pobyte');
  },
};
</script>
